<template>
    <div>
        <div class="overflow-x-auto shadow-md sm:rounded-lg mb-3 mr-4">
            <table
                class="w-full text-sm text-left text-gray-500 dark:text-gray-400 border"
            >
                <thead
                    class="text-xs text-gray-700 uppercase bg-white dark:bg-White dark:text-black"
                >
                    <tr>
                        <th scope="col" class="px-6 py-3">Day</th>
                        <th scope="col" class="px-6 py-3 mx-auto">Start</th>
                        <th scope="col" class="px-6 py-3">End</th>
                        <th scope="col" class="px-6 py-3 flex flex-row-reverse">
                            Any Time
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        class="border-b dark:bg-white dark:border-gray-200"
                        v-for="(day, key) in hours"
                        :key="key"
                    >
                        <th
                            scope="row"
                            class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-fray-300"
                        >
                            {{ day.name }}
                        </th>
                        <td class="px-1 py-4">
                            <div class="mx-auto rounded">
                                <div
                                    class="inline-flex text-lg border rounded-lg"
                                >
                                    <TimePicker
                                        @update-time="updateTime"
                                        :day="day.name"
                                        :type="'start'"
                                        :times="day.start"
                                        :clickable="day.closed"
                                        :storefront="false"
                                    />
                                </div>
                            </div>
                        </td>
                        <td class="relative px-1 py-4">
                            <div class="mx-auto rounded">
                                <div
                                    class="inline-flex text-lg border rounded-lg"
                                >
                                    <TimePicker
                                        @update-time="updateTime"
                                        :day="day.name"
                                        :times="day.end"
                                        :type="'end'"
                                        :clickable="day.closed"
                                        :storefront="false"
                                        append-to-body
                                    />
                                </div>
                            </div>
                        </td>
                        <td class="px-6 py-4 text-right">
                            <t-checkbox name="options" v-model="day.closed" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import TimePicker from "../partials/TimePicker.vue";
export default {
    data() {
        return {
            hours: {
                Monday: {
                    name: "Monday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Tuesday: {
                    name: "Tuesday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Wednesday: {
                    name: "Wednesday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Thursday: {
                    name: "Thursday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Friday: {
                    name: "Friday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Saturday: {
                    name: "Saturday",
                    start: null,
                    end: null,
                    closed: true,
                },
                Sunday: {
                    name: "Sunday",
                    start: null,
                    end: null,
                    closed: true,
                },
            },
        };
    },
    props: ["hoursType", "user"],
    components: { TimePicker },
    watch: {
        hours: {
            handler() {
                this.$emit("changed", this.createArrayToEmit());
            },
            deep: true,
        },
    },
    methods: {
        createArrayToEmit() {
            let resultArray = [];
            Object.keys(this.hours).forEach((key, index) => {
                if (!this.hours[key].closed) {
                    resultArray.push({
                        day_of_week: this.getISOWeekDayNumber(key),
                        start_time: this.hours[key].start,
                        end_time: this.hours[key].end,
                        usage: this.getScheduleItemUsage(),
                    });
                }
            });
            return resultArray;
        },
        getISOWeekDayNumber(day) {
            switch (day) {
                case "Monday":
                    return 1;
                    break;
                case "Tuesday":
                    return 2;
                    break;
                case "Wednesday":
                    return 3;
                    break;
                case "Thursday":
                    return 4;
                    break;
                case "Friday":
                    return 5;
                    break;
                case "Saturday":
                    return 6;
                    break;
                case "Sunday":
                    return 7;
                    break;
                default:
                    return null;
            }
        },
        updateTime(e) {
            if (e.val.A == "PM" && parseInt(e.val.hh) != 12) {
                this.hours[e.day][e.type] =
                    (parseInt(e.val.hh) + 12).toString() + e.val.mm;
            } else if (e.val.A == "AM" && parseInt(e.val.hh) == 12) {
                this.hours[e.day][e.type] = "00" + e.val.mm;
            } else {
                this.hours[e.day][e.type] = e.val.hh + e.val.mm;
            }
        },
        getISOWeekDayName(day) {
            switch (day) {
                case 1:
                    return "Monday";
                    break;
                case 2:
                    return "Tuesday";
                    break;
                case 3:
                    return "Wednesday";
                    break;
                case 4:
                    return "Thursday";
                    break;
                case 5:
                    return "Friday";
                    break;
                case 6:
                    return "Saturday";
                    break;
                case 7:
                    return "Sunday";
                    break;
                default:
                    return null;
            }
        },
        getScheduleItemUsage() {
            if (this.hoursType == "personal") return 0;
        },
    },
    mounted() {
        this.user.schedule.forEach((hoursDataItem) => {
            if (hoursDataItem.usage == this.getScheduleItemUsage()) {
                this.hours[this.getISOWeekDayName(hoursDataItem.day_of_week)] =
                    {
                        name: this.getISOWeekDayName(hoursDataItem.day_of_week),
                        start:
                            hoursDataItem.start_time === null
                                ? "0900"
                                : hoursDataItem.start_time,
                        end:
                            hoursDataItem.end_time === null
                                ? "1700"
                                : hoursDataItem.end_time,
                        closed: hoursDataItem.closed,
                    };
            }
        });
    },
};
</script>
